export default {
  name: 'Plushie',
  path: '/plushie',
  meta: {
    title: 'Momo the Cat Plushie'
  }
};
